// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"7fe95281","470":"14a044e0","934":"6e43abc8","948":"764a3e5d"}[chunkId] + ".chunk.css";
};